import jwtDecode from "jwt-decode";

// FeaturesId pode vir como array ou como texto "[7,16]"; o MAUI só lê texto
export function normalizeFeaturesId(raw) {
    if (Array.isArray(raw)) return raw.map(Number);
    if (typeof raw === "number") return [raw];
    if (typeof raw !== "string" || raw.trim() === "") return [];

    try {
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed.map(Number) : [Number(parsed)];
    } catch {
        return raw.split(",").map(Number).filter((id) => !Number.isNaN(id));
    }
}

export default function decodeToken(token) {
    try {
        const decoded = jwtDecode(token);
        if (decoded) decoded.FeaturesId = normalizeFeaturesId(decoded.FeaturesId);
        return decoded;
    } catch (error) {
        console.error("Error decoding token", error);
        return null;
    }
}
